/**
 * @public
 */
export function transactionErrored(transaction) {
  return 'errorMessage' in transaction;
}